export default __webpack_public_path__ + "static/Corprate_WhoWeAre_InternationalFranchises_01-56b14c1c63843792e1f544d017021a52.jpg";